import { BillingAddressContainer } from "../../../../../../common/billing-address/containers/billing-address.container"
import { AccordionContainer } from "../../../../../../common/components/accordion/accordion.module"
import { InputContainer } from "../../../../../../common/components/form/form.module"
import storePersist from "../../../../../../redux/storePersist"

export const GatewayOpenNetworkSubscription = ({ selectedGateway, domainItems, accountData, onClose, onInnerFormChange }: any) => {
    console.log('accountData', accountData)
    const librariesItems = storePersist?.get("library")?.current;

    return (
        <>
            <h1 className="text-xl font-bold mb-4 text-center">Open Network Subscription</h1>
            <AccordionContainer
                child={
                    <>
                        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                            <InputContainer
                                label="Business Name"
                                name="Name"
                                onValueChange={(event: any) => {
                                    onInnerFormChange(
                                        event.target.value,
                                        'AccountInfo.Name',
                                        accountData?.AccountInfo
                                    )
                                }}
                                type="text"
                                value={accountData?.AccountInfo?.Name}
                            />
                            <InputContainer
                                label="GST Number"
                                name="GSTNumber"
                                onValueChange={(event: any) => {
                                    onInnerFormChange(
                                        event.target.value,
                                        'GSTInfo.GSTNumber',
                                        accountData?.GSTInfo
                                    )
                                }}
                                type="text"
                                value={accountData?.GSTInfo?.GSTNumber}
                            />
                            <InputContainer

                                label="PAN Number"
                                name="PANNumber"
                                onValueChange={(event: any) => {
                                    onInnerFormChange(
                                        event.target.value,
                                        'GSTInfo.PANNumber',
                                        accountData?.GSTInfo
                                    )
                                }}
                                type="text"
                                value={accountData?.GSTInfo?.PANNumber}
                            />

                            <InputContainer

                                label="Incorporation Date"
                                name="PANNumber"
                                onValueChange={(event: any) => {
                                    onInnerFormChange(
                                        event.target.value,
                                        'GSTInfo.PANNumber',
                                        accountData?.GSTInfo
                                    )
                                }}
                                type="text"
                                value={accountData?.GSTInfo?.PANNumber}
                            />

                            <InputContainer

                                label="City Codes"
                                name="PANNumber"
                                onValueChange={(event: any) => {
                                    onInnerFormChange(
                                        event.target.value,
                                        'GSTInfo.PANNumber',
                                        accountData?.GSTInfo
                                    )
                                }}
                                type="multiselect"
                                value={accountData?.GSTInfo?.PANNumber}
                            />
                            <InputContainer

                                label="Authorized signatory"
                                name="PANNumber"
                                onValueChange={(event: any) => {
                                    onInnerFormChange(
                                        event.target.value,
                                        'GSTInfo.PANNumber',
                                        accountData?.GSTInfo
                                    )
                                }}
                                type="multiselect"
                                value={accountData?.GSTInfo?.PANNumber}
                            />

                            {/* <BillingAddressContainer
                                isAddress
                                onInnerFormChange={onInnerFormChange}
                                selectBillingAddress={accountData?.AccountAddress?.PrimaryAddress}
                            /> */}

                            <InputContainer
                                // isDisabled={id !== '0'}
                                label="Email"
                                name="Email"
                                onValueChange={(event: any) => {
                                    onInnerFormChange(
                                        event.target.value,
                                        'LoginInfo.Email',
                                        accountData?.LoginInfo
                                    );
                                }}
                                type="text"
                                value={accountData?.LoginInfo?.Email}
                            />
                            <InputContainer
                                // isDisabled={id !== '0'}
                                label="PhoneNumber"
                                name="PhoneNumber"
                                onValueChange={(event: any) => {
                                    onInnerFormChange(
                                        event.target.value,
                                        'LoginInfo.PhoneNumber',
                                        accountData?.LoginInfo
                                    );
                                }}
                                type="number"
                                value={accountData?.LoginInfo?.PhoneNumber}
                            />
                            <InputContainer
                                // isDisabled={id !== '0'}
                                label="Country"
                                name="PhoneNumber"
                                onValueChange={(event: any) => {
                                    onInnerFormChange(
                                        event.target.value,
                                        'LoginInfo.PhoneNumber',
                                        accountData?.LoginInfo
                                    );
                                }}
                                type="number"
                                value={accountData?.LoginInfo?.PhoneNumber}
                            />

                        </div>
                    </>
                }
                expandedPanel="Entity Info"
                headerTitle="Entity Info"
            />

            {/* <div >
                <BillingAddressContainer
                    isAddress
                    onInnerFormChange={onInnerFormChange}
                    selectBillingAddress={accountData?.AccountAddress?.PrimaryAddress}
                />
            </div> */}

            <AccordionContainer
                child={
                    <>
                        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                            <InputContainer
                                label="Subscriber Url"
                                name="SubscriberUrl"
                                onValueChange={(event: any) => {
                                    onInnerFormChange(
                                        event.target.value,
                                        'SubscriberUrl',

                                    )
                                }}
                                type="text"
                                value={selectedGateway?.SubscriberUrl}
                            />
                            <InputContainer
                                label="Status"
                                name="Status"
                                onValueChange={(event: any) => {
                                    onInnerFormChange(
                                        event.target.value,
                                        'Status',

                                    )
                                }}
                                type="text"
                                value={selectedGateway?.Status}
                            />
                            <InputContainer
                                isDisabled
                                label="Type"
                                labelField="Type"
                                onValueChange={(event: any) => {
                                    onInnerFormChange(
                                        event.target.value,
                                        'Type'
                                    )
                                }}
                                type="text"
                                value={selectedGateway?.Type}

                            />
                            <InputContainer
                                label="Domain Name"
                                labelField="Name"
                                list={domainItems?.result?.items}
                                onValueChange={(newValue: any) => {
                                    const valueData: any = newValue.map((option: any) => option?.value || '',)
                                    console.log('valueData', valueData)
                                    onInnerFormChange(
                                        valueData,
                                        'Domains'
                                    )
                                }}
                                type="multiselect"
                                valueField="Id"
                                value={selectedGateway?.Domains}
                            />
                        </div>
                    </>
                }
                expandedPanel="Network Participants"
                headerTitle="Network Participants"
            />
        </>
    )
}